// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ha-j";
export var fulfillmentFormRail = "_ha-i";
export var headerTitleRow = "_ha-l";
export var orderDetailsWrapper = "_ha-g";
export var orderLinkTrigger = "_ha-2";
export var paymentInformationGrid = "_ha-q";
export var paymentSummaryColumn = "_ha-r";
export var phoneShipmentPickerButton = "_ha-e";
export var phoneShipmentPickerButtonContent = "_ha-f";
export var phoneShipmentPickerButtonWrapper = "_ha-d";
export var phoneShipmentPickerTrigger = "_ha-c";
export var shipmentContainer = "_ha-k";
export var shipmentDetailsMainPane = "_ha-h";
export var shipmentNavigationCard = "_ha-a";
export var shipmentNavigationEdgeTrigger = "_ha-6";
export var shipmentNavigationRail = "_ha-3";
export var shipmentNavigationRailEnter = "_ha-5";
export var shipmentNavigationRailHeader = "_ha-9";
export var shipmentNavigationRailOverlay = "_ha-4";
export var shipmentNavigationScrim = "_ha-7";
export var shipmentSummaryFact = "_ha-n";
export var shipmentSummaryGrid = "_ha-m";
export var shipmentSummaryMetadataRow = "_ha-o";
export var shipmentSummaryTags = "_ha-p";
export var shipmentWorkspace = "_ha-0";
export var shipmentWorkspaceBodyTablet = "_ha-8";
export var shipmentWorkspaceContent = "_ha-b";
export var shipmentWorkspaceHeader = "_ha-1";